// export const CADSystems = [
//   'Inform CAD', 'TotalCommand', 'Intergraph I/CAD', 'PremierOne', 'RapidDeploy',
//   'SafetyNet CAD', 'Spillman', 'Zetron CAD', 'Zuercher', 'Other'
// ];
//
// export const MappingSystems = [
//   'GeoConex', 'GeoLynx', 'VESTA Map Local', 'DDTI', 'Other'
// ];
//
// export const PhoneSystems = [
//   'Callworks', 'Guardian', 'Zetron Max CT', 'VESTA', 'Viper', 'Other'
// ];

// ENUM name-value mappings from backend in geofence/impl/schemas.py
export const CADSystems = [
  {
    name: 'Inform CAD',
    enumMapping: 1,
  },
  {
    name: 'Total Command',
    enumMapping: 2,
  },
  {
    name: 'Intergraph I/CAD',
    enumMapping: 3,
  },
  {
    name: 'PremierOne',
    enumMapping: 4,
  },
  {
    name: 'RapidDeploy',
    enumMapping: 5,
  },
  {
    name: 'SafetyNet CAD',
    enumMapping: 9,
  },
  {
    name: 'Spillman',
    enumMapping: 6,
  },
  {
    name: 'Zetron CAD',
    enumMapping: 7,
  },
  {
    name: 'Zuercher',
    enumMapping: 8,
  },
  {
    name: 'Other',
    enumMapping: 0,
  },
  // other = 0
  // inform_cad = 1
  // totalcommand = 2
  // intergraph_i_cad = 3
  // premierone = 4
  // rapiddeploy = 5
  // spillman = 6
  // zetron_cad = 7
  // zuercher = 8
  // safetynet_cad = 9
];

export const MappingSystems = [
  {
    name: 'GeoConex',
    enumMapping: 1,
  },
  {
    name: 'GeoLynx',
    enumMapping: 2,
  },
  {
    name: 'VESTA Map Local',
    enumMapping: 3,
  },
  {
    name: 'DDTI',
    enumMapping: 4,
  },
  {
    name: 'Other',
    enumMapping: 0,
  },
  // other = 0
  // geoconex = 1
  // geolynx = 2
  // vesta_map_local = 3
  // ddti = 4
];

export const PhoneSystems = [
  {
    name: 'Callworks',
    enumMapping: 1,
  },
  {
    name: 'Guardian',
    enumMapping: 2,
  },
  {
    name: 'Zetron Max CT',
    enumMapping: 3,
  },
  {
    name: 'Vesta',
    enumMapping: 4,
  },
  {
    name: 'Viper',
    enumMapping: 5,
  },
  {
    name: 'Other',
    enumMapping: 0,
  },
  // other = 0
  // callworks = 1
  // guardian = 2
  // zetron_max_ct = 3
  // vesta = 4
  // viper = 5
];

export const AgencyStates = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AS', label: 'American Samoa' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'DC', label: 'District of Columbia' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'GU', label: 'Guam' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'MP', label: 'Northern Mariana Islands' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'PI', label: 'Philippine Islands' },
  { value: 'PR', label: 'Puerto Rico' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VI', label: 'Virgin Islands' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' },
];
